import React, { useEffect, useRef, useState } from "react";
import DecorativeSquares from "../../components/ui/DecorativeSquares";
import { useNavigate } from "react-router-dom";
import { Edit3, Lock, Trash, InfoIcon, CircleUserRound } from "lucide-react";
import { TextInput, NumberInput, Select } from "../../components/form/inputs";
import PrimaryBtn from "../../components/button/PrimaryBtn";
import DeleteSwal from "../../components/Swals/DeleteSwal";
import canadaFlg from "../../assets/images/svgs/country/canada.svg";
import indianFlg from "../../assets/images/svgs/country/india.svg";
import usaFlg from "../../assets/images/svgs/country/usa.svg";
import Changepass from "../../components/Modals/Changepass";
import PdShimmer from "../../components/Preloader/PdShimmer";
import PersonalShimmer from "../../components/Preloader/PersonalShimmer";
import {
  getProfileDetail,
  addOrUpdateProvider,
  changePassWord,
  deleteAcc,
} from "../../redux/thunks/profileThunk";
import { useDispatch, useSelector } from "react-redux";
import {
  getCountry,
  getAvtar,
  uploadPhoto,
} from "../../redux/thunks/registerThunks";
import AvatarShimmer from "../../components/Preloader/AvatarShimmer";
import toast from "react-hot-toast";
import { clearToken } from "../../redux/slices/authSlice";
import { FaArrowLeft } from "react-icons/fa";

const Personal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fileRef = useRef(null);
  const [uploadedImg, setUploadedImg] = useState(null);
  const [getImage, setGetImage] = useState(null);
  const [images, setImages] = useState([]);
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [isChangePasword, setIsChangePassword] = useState(false);
  const [countryCode, setCountryCode] = useState("+91");
  const [userId, setUserId] = useState("");
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    username: "Sven Ryan",
    email: "svenryan234@gmail.com",
    mobile: "9187741106",
    country_id: "+91",
  });
  const user_id = useSelector((state) => state.auth.user?.id);

  // console.log("The user id is :", user_id);

  const COUNTRY_FLAGS = {
    99: indianFlg,
    38: canadaFlg,
    226: usaFlg,
  };

  const {
    avatars: avatarsFromApi,
    countries: countryFromApi,
    loading,
  } = useSelector((state) => state.setupProfile);

  useEffect(() => {
    dispatch(getAvtar());
    dispatch(getCountry());
  }, [dispatch]);

  const avatars =
    avatarsFromApi?.map((av) => ({
      id: av.id,
      img: av.image_url,
    })) || [];

  const countries = countryFromApi?.map((cu) => {
    const normalizedName =
      cu.country_name.charAt(0).toUpperCase() +
      cu.country_name.slice(1).toLowerCase();

    return {
      id: cu.id,
      value: cu.id,
      label: ` +${cu.country_code}`,
      image: COUNTRY_FLAGS[cu.id] || null, // ✅ FIXED
      min_phone_length: cu.min_phone_length,
      max_phone_length: cu.max_phone_length,
      country_code: cu.country_code,
    };
  });

  useEffect(() => {
    if (!countries?.length) return;

    const selected = countries.find((c) => c.value === formData.country_id);

    if (selected) {
      setCountryCode(`+${selected.country_code}`);
    }
  }, [formData.country_id, countries]);

  // const selectedCountry = countries.find((c) => c.value === countryCode);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedAvatar(null);
    setImages([{ preview: URL.createObjectURL(file), file }]);
  };

  const handleAvatarSelect = (avatar) => {
    setImages([]); // remove uploaded image
    setSelectedAvatar(avatar); // set avatar
  };
  useEffect(() => {
    dispatch(getProfileDetail())
      .unwrap()
      .then((res) => {
        const data = res.data;
        // console.log("the data is :", res.data);
        setFormData((prev) => ({
          ...prev,
          username: data.name,
          email: data.email,
          mobile: data.contact_no,
          country_id: data.country_id,
        }));

        const userID = data.user_id;
        setUserId(userID);
        // console.log("The user id of perticular user is :", userId);

        setGetImage(data.user_profile_image || null);

        // 🔥 AVATAR FIX
        if (data.user_avatar_id && avatarsFromApi?.length) {
          const matchedAvatar = avatarsFromApi.find(
            (av) => av.id === data.user_avatar_id,
          );

          if (matchedAvatar) {
            setSelectedAvatar({
              id: matchedAvatar.id,
              img: matchedAvatar.image_url,
            });
          }
        }
      });
  }, [dispatch, avatarsFromApi]);

  // ✅ Validation function
  const validateDetails = () => {
    const newErrors = {};

    if (!formData.username || formData.username.trim() === "") {
      newErrors.username = "Name is required";
    }

    if (!formData.email || formData.email.trim() === "") {
      newErrors.email = "Email is required";
    } else {
      // Optional: simple email regex
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = "Invalid email format";
      }
    }

    if (!formData.mobile || formData.mobile.trim() === "") {
      newErrors.mobile = "Mobile number is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const onHandleSave = async () => {
    if (!validateDetails()) {
      // alert("validation failed");
      return;
    }
    // alert("Clicked after validation");

    try {
      let uploadedFileName = null;

      if (images.length) {
        const imgForm = new FormData();
        imgForm.append("type", "provider_profile_image"); // ✅ FIX
        imgForm.append("image", images[0].file);

        const uploadRes = await dispatch(uploadPhoto(imgForm)).unwrap();
        uploadedFileName = uploadRes.data?.temp_image_name;
      }

      // console.log("The uploaded image is :", uploadedFileName);

      const payload = {
        user_name: formData.username,
        user_contact_no: formData.mobile,
        country_id: formData.country_id,
        user_email: formData.email,
        user_avatar_id: selectedAvatar ? selectedAvatar.id : null,
        user_profile_image: uploadedFileName || null, // ✅ SAFE
      };

      // console.log("FINAL payload:", payload);

      const res = await dispatch(addOrUpdateProvider(payload)).unwrap();
      // console.log("payload after dispatch :", payload);
      toast.success(res.message || "Profile updated");
      dispatch(getProfileDetail());
      navigate("/profile");
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Something went wrong");
    }
  };
  const handleChangePassword = async (data) => {
    // console.log("Password Payload 👉", data);

    // Frontend validation
    if (data.new_pass !== data.confirm_pass) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      await dispatch(
        changePassWord({
          user_id: user_id,
          old_password: data.old_pass,
          new_password: data.new_pass,
          new_password_confirmation: data.confirm_pass,
        }),
      ).unwrap();

      toast.success("Password changed successfully");
      setIsChangePassword(false);
    } catch (err) {
      // console.error("Change password error:", err);

      toast.error(
        typeof err === "string"
          ? err
          : err?.message || "Failed to change password",
      );
    }
  };

  const handleAccoutDel = () => {
    DeleteSwal({
      cancleColor: "",
      title: "Delete Account",
      text: "Are you sure you want to delete your account?",
      icon: CircleUserRound,
      note: (
        <div className="mt-3 rounded-xl border border-yellow-300 bg-yellow-50  text-left">
          <div className="flex items-start gap-2 mb-2">
            <div className="h-6 w-6 flex items-center justify-center rounded-full bg-yellow-200">
              <InfoIcon size={16} className="text-yellow-700" />
            </div>
            <h4 className="font-semibold text-yellow-800">
              Important Information
            </h4>
          </div>

          <ul className="list-disc pl-8 space-y-2 text-sm text-yellow-900">
            <li>
              If you log in within <strong>30 days</strong>, your account will
              be restored with all your data intact.
            </li>
            <li>
              After 30 days, your account and all associated data will be
              permanently deleted and cannot be recovered.
            </li>
            <li>
              If you delete your account,{" "}
              <strong>all active subscription</strong> and{" "}
              <strong>all associated data</strong> will be permanently{" "}
              <strong className="text-red-500">deleted</strong> and cannot be
              recovered
            </li>
            <li>
              To use our service again after permanent deletion, you will need
              to register with a new account.
            </li>
          </ul>
        </div>
      ),
      onConfirm: async () => {
        localStorage.removeItem("9zIBz91iaMa33UPXalZiOH7mnILWM1af");
        sessionStorage.removeItem("9zIBz91iaMa33UPXalZiOH7mnILWM1af");
        localStorage.removeItem("isAuthenticated");
        localStorage.removeItem("currency");
        localStorage.removeItem("email");
        localStorage.removeItem("isToday");
        localStorage.removeItem("is_add_reg");
        localStorage.removeItem("is_reg_completed");
        localStorage.removeItem("meal_external_tab");
        localStorage.removeItem("lpCr0HsSLPU3FGP5AUbrIiMUh9lcU6ZS");
        localStorage.removeItem("subscribe_tab");
        localStorage.removeItem("setup_tab");
        try {
          const res = await dispatch(
            deleteAcc({
              user_id: userId,
              is_confirmed: 1,
            }),
          ).unwrap();

          toast.success(res?.message || "Account deleted successfully");
          dispatch(clearToken());
          navigate("/");
        } catch (err) {
          console.error("Delete account error:", err);

          toast.error(
            typeof err === "string"
              ? err
              : err?.message || "Failed to delete account",
          );
        }
      },
    });
  };

  return (
    <>
      {loading ? (
        <>
          {" "}
          <PersonalShimmer />{" "}
        </>
      ) : (
        <>
          <section className="relative max-w-7xl mx-auto px-4 md:px-6 py-4">
            <DecorativeSquares />

            {/* ================= HEADER ================= */}
            <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
              <button
                onClick={() => navigate("/profile")}
                className="p-2 rounded-full hover:bg-gray-100"
              >
                <FaArrowLeft size={20} />
              </button>
              <h1 className="text-xl md:text-2xl font-semibold text-gray-900">
                Personal Details
              </h1>
              <div className="w-10" />
            </div>

            {/* ================= PROFILE CARD ================= */}
            {loading ? (
              <>
                <PdShimmer />
              </>
            ) : (
              <>
                <div className="mt-10 bg-gradient-to-br from-orange-50 to-white border rounded-3xl p-8 text-center shadow-sm">
                  <div className="relative w-fit mx-auto">
                    <img
                      src={
                        images.length > 0
                          ? images[0].preview // new upload preview
                          : selectedAvatar
                            ? selectedAvatar.img // avatar
                            : getImage // backend image
                      }
                      alt="profile"
                      className="w-36 h-36 rounded-full object-cover ring-4 ring-white shadow-md"
                    />

                    {/* hidden input */}
                    <input
                      ref={fileRef}
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={handleImageUpload}
                    />

                    {/* edit button */}
                    <button
                      type="button"
                      onClick={() => fileRef.current.click()}
                      className="
                  absolute bottom-2 right-2
                  bg-[#FF6943] text-white
                  w-9 h-9 rounded-full
                  flex items-center justify-center
                  shadow-md
                  hover:scale-105 transition
                "
                    >
                      <Edit3 size={16} />
                    </button>
                  </div>

                  <h3 className="mt-4 text-lg font-semibold">
                    {formData.username}
                  </h3>
                  <p className="text-sm text-gray-500">{formData.email}</p>

                  <p className="mt-4 text-sm text-gray-500 max-w-md mx-auto">
                    Update your personal information and choose a profile
                    avatar.
                  </p>
                </div>
              </>
            )}

            {/* ================= FORM CARD ================= */}
            <form className="mt-8 md:mt-14 bg-white border rounded-3xl p-6 md:p-8 shadow-sm">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-10">
                {/* LEFT : FORM */}
                <div className="space-y-5">
                  <TextInput
                    label="Full Name"
                    required={true}
                    name="username"
                    value={formData.username}
                    onChange={(e) => {
                      handleChange(e); // formData update
                      setErrors((prev) => ({ ...prev, username: "" })); // clear username error
                    }}
                  />
                  {errors.username && (
                    <p className="text-sm text-red-500 mt-1">
                      {errors.username}
                    </p>
                  )}

                  <TextInput
                    required={true}
                    label="Email Address"
                    name="email"
                    value={formData.email}
                    onChange={(e) => {
                      handleChange(e);
                      setErrors((prev) => ({ ...prev, email: "" }));
                    }}
                  />
                  {errors.email && (
                    <p className="text-sm text-red-500 mt-1">{errors.email}</p>
                  )}
                  <div>
                    <p className="font-medium text-sm">
                      {" "}
                      Contact No
                      <span className="text-red-500 ml-1">*</span>{" "}
                    </p>
                    <div className="flex gap-3 mb-4 items-center">
                      {/* Country Code */}

                      <div className="w-32">
                        <Select
                          name="country_id"
                          required={true}
                          value={formData.country_id} // ✅ now matches option.value
                          onChange={(val) =>
                            setFormData((p) => ({
                              ...p,
                              country_id: Number(val), // now val direct value hai
                            }))
                          }
                          options={countries}
                          variant="withImages"
                          displaySelected="label"
                        />
                      </div>

                      {/* Mobile Number */}
                      <div className="w-2/3">
                        <NumberInput
                          required={true}
                          value={formData.mobile}
                          onChange={(e) => {
                            handleChange(e);
                            setErrors((prev) => ({ ...prev, mobile: "" }));
                          }}
                          placeholder="Enter mobile number"
                        />
                      </div>
                      {errors.mobile && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors.mobile}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* RIGHT : AVATARS */}
                <div>
                  <p className="mb-3 text-sm font-semibold text-gray-700">
                    Choose Avatar
                  </p>
                  <div>
                    {loading ? (
                      <AvatarShimmer count={8} />
                    ) : (
                      <div className="grid grid-cols-4 gap-3 border rounded-xl p-3">
                        {avatars.map((avatar) => (
                          <div
                            key={avatar.id}
                            onClick={() => handleAvatarSelect(avatar)}
                            className="relative cursor-pointer w-20 h-20 rounded-xl overflow-hidden"
                          >
                            {selectedAvatar?.id === avatar.id && (
                              <div className="absolute top-2 left-2 bg-[#FF6943] text-white rounded-full h-5 w-5 flex items-center justify-center text-xs">
                                ✓
                              </div>
                            )}
                            <img
                              src={avatar.img}
                              className="w-full h-full object-cover"
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* ================= ACTIONS ================= */}
              <div className="pt-6   flex flex-col justify-center items-center md:flex-row md:justify-between gap-4">
                <div className="w-full h-px bg-green-400/40 backdrop-blur-sm md:hidden" />
                <button
                  onClick={() => setIsChangePassword(true)}
                  type="button"
                  className="flex items-center gap-2 text-orange-500 font-semibold hover:underline"
                >
                  <Lock size={18} /> Change Password
                </button>
                <div className="w-full h-px bg-green-400/40 backdrop-blur-sm md:hidden" />
                <button
                  type="button"
                  onClick={handleAccoutDel}
                  className="flex items-center gap-2 text-red-500 font-semibold hover:underline"
                >
                  <Trash size={18} /> Delete Account
                </button>
                <div className="w-full h-px bg-green-400/40 backdrop-blur-sm md:hidden" />
              </div>
              <div className="mt-10 flex justify-end">
                <PrimaryBtn
                  btnName="Save Changes"
                  clickEvent={onHandleSave}
                  isLoading={loading}
                />
              </div>
            </form>

            {/* ================= SAVE ================= */}

            <Changepass
              open={isChangePasword}
              onClose={() => setIsChangePassword(false)}
              onSubmit={handleChangePassword}
            />
          </section>
        </>
      )}
    </>
  );
};

export default Personal;
